import { Button, RadioGroup, Stack, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { TAB_VALUE_TYPE } from '..';

interface IFilterTags {
  tabValue: number;
  handleTabChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

export const FilterTags = ({ tabValue, handleTabChange }: IFilterTags) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  const isDesktop = useIsDesktop();

  const buttonStyle: SxProps = {
    border: '1px solid',
    borderColor: 'primary.shade_100',
    p: isDesktop ? '12px 20px' : '4px 12px',
  };

  return (
    <Stack gap='24px' mt='32px'>
      <Typography variant='h6'>{dictionary.selectBy}</Typography>
      <RadioGroup
        sx={{ gap: '24px' }}
        aria-label={dictionary.selectBy}
        row={true}
      >
        <Button
          variant='outlined'
          sx={{
            ...buttonStyle,
            bgcolor: tabValue === TAB_VALUE_TYPE.SUBJECTS ? '#1552E8' : 'white',
          }}
          onClick={(e) => handleTabChange(e, TAB_VALUE_TYPE.SUBJECTS)}
          role='radio'
        >
          <Typography
            color={tabValue === TAB_VALUE_TYPE.SUBJECTS ? 'white' : undefined}
            variant='body3'
          >
            {dictionary.choseBy[TAB_VALUE_TYPE.SUBJECTS]}
          </Typography>
        </Button>
        <Button
          variant='outlined'
          sx={{
            ...buttonStyle,
            bgcolor:
              tabValue === TAB_VALUE_TYPE.DEPARTMENT ? '#1552E8' : 'white',
          }}
          onClick={(e) => handleTabChange(e, TAB_VALUE_TYPE.DEPARTMENT)}
          role='radio'
        >
          <Typography
            color={tabValue === TAB_VALUE_TYPE.DEPARTMENT ? 'white' : undefined}
            variant='body3'
          >
            {dictionary.choseBy[TAB_VALUE_TYPE.DEPARTMENT]}
          </Typography>
        </Button>
        <Button
          variant='outlined'
          sx={{
            ...buttonStyle,
            bgcolor: tabValue === TAB_VALUE_TYPE.ALL ? '#1552E8' : 'white',
          }}
          onClick={(e) => handleTabChange(e, TAB_VALUE_TYPE.ALL)}
          role='radio'
        >
          <Typography
            color={tabValue === TAB_VALUE_TYPE.ALL ? 'white' : undefined}
            variant='body3'
          >
            {dictionary.choseBy[TAB_VALUE_TYPE.ALL]}
          </Typography>
        </Button>
      </RadioGroup>
    </Stack>
  );
};
